'use strict';
import React from 'react';
import PropTypes from 'prop-types';

const EmptyInfo = ({children}) => <div className='empty-info'>{children}</div>;

EmptyInfo.propTypes = { children: PropTypes.node };

export default EmptyInfo;
